import CloseIcon from "@mui/icons-material/Close";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import {
  Drawer,
  Toolbar,
  List,
  ListItemIcon,
  ListItemText,
  ListItemButton,
  Box,
  IconButton,
  Typography,
} from "@mui/material";
import Collapse from "@mui/material/Collapse";
import React, { PropsWithoutRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { SIDEBAR_WIDTH } from "../constants";

interface Props {
  mobileOpen: boolean;
  handleSidebarToggle: () => void;
}

const sidebarData = [
  {
    title: "Dashboard",
    icon: "/static/images/dashboard.png",
    path: "/dashboard",
  },
  {
    title: "Users",
    icon: "/static/images/registrations.png",
    path: "/users",
  },
  {
    title: "Manage Vehicles",
    icon: "/static/images/manageCar.png",
    path: "/listings/individual",
  },
  {
    title: "Manage Partners",
    icon: "/static/images/partners.png",
    path: "/manage-partners",
  },
  // {
  //   title: "Manage Discount",
  //   icon: "/static/images/discount.png",
  //   path: "/manage-discount",
  // },
  {
    title: "Bookings",
    icon: "/static/images/list.png",
    path: "/bookings",
  },
  {
    title: "Manage Categories",
    icon: "/static/images/category.png",
    path: "/categories",
  },
  {
    title: "Subscriptions",
    icon: "/static/images/subscription.png",
    path: "/subscriptions/manage-subscriptions",
    // collapseKey: "openSubscriptions",
    // children: [
    //   {
    //     title: "Manage Subscriptions",
    //     path: "/subscriptions/manage-subscriptions",
    //   },
    //   {
    //     title: "Manage Active Subscriptions",
    //     path: "/subscriptions/manage-active-subscriptions",
    //   },
    // ],
  },
  {
    title: "Manage Investment",
    icon: "/static/images/growth.png",
    collapseKey: "openInvestment",
    children: [
      {
        title: "Reporting Dashboard",
        path: "/manage-investments/reporting-dashboard",
      },
      {
        title: "Investor Applications",
        path: "/manage-investments/investor-applications",
      },
      {
        title: "Agreement Management",
        path: "/manage-investments/agreement-management",
      },
      {
        title: "Investment Plans",
        path: "/manage-investments/investment-plans",
      },
      // {
      //   title: "ROI Management",
      //   path: "/manage-investments/roi-management",
      // },
    ],
  },

  {
    title: "Manage Sub-admin",
    icon: "/static/images/admin-panel.png",
    collapseKey: "openSubadmin",
    children: [
      { title: "Roles", path: "/user-management/roles" },
      { title: "Subadmin List", path: "/user-management/user-list" },
    ],
  },
  {
    title: "Manage Notifications",
    icon: "/static/images/notification_icon.png",
    path: "/manage-notifications",
  },

  {
    title: "Manage CMS",
    icon: "/static/images/cms.png",
    path: "/manage-cms",
  },

  {
    title: "Sales Report",
    icon: "/static/images/analytics.png",
    path: "/manage-analytics",
  },
  {
    title: "Customer Support",
    icon: "/static/images/registrations.png",
    path: "/manage-CustomerSupport",
  },
];

export default function Sidebar({ mobileOpen, handleSidebarToggle }: Props) {
  const location = useLocation();
  const navigate = useNavigate();

  const [collapseState, setCollapseState] = React.useState<
    Record<string, boolean>
  >({
    openRegistrations: true,
    openListings: true,
    openSpecs: true,
    openSubadmin: true,
    openInvestment: true,
    openSubscriptions: true,
  });

  const handleCollapseToggle = (key: string) => {
    setCollapseState((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  const drawer = (
    <>
      <Toolbar className="sidebar-logo" sx={{ position: "relative" }}>
        <div style={{ alignSelf: "center" }}>
          <figure>
            <img
              src="/static/images/logo.png"
              alt=""
              onClick={() => navigate("/dashboard")}
              style={{
                width: "200px",
                height: "110px",
              }}
            />
          </figure>
        </div>
        <IconButton
          sx={{
            position: "absolute",
            top: 10,
            right: 10,
            color: "white",
            display: { lg: "none" },
          }}
          onClick={handleSidebarToggle}
        >
          <CloseIcon />
        </IconButton>
      </Toolbar>

      <List sx={{ flexGrow: 1 }} className="sidebr-lst">
        {sidebarData.map((item, index) => {
          const isActive = location.pathname === item.path;
          const isCollapseOpen = item.collapseKey
            ? !collapseState[item.collapseKey]
            : false;
          const isParentActive =
            item.children?.some((child) => location.pathname === child.path) ??
            false;

          return (
            <React.Fragment key={index}>
              <ListItemButton
                className="lst-itm"
                selected={isActive || isParentActive}
                onClick={() =>
                  item.children
                    ? handleCollapseToggle(item.collapseKey!)
                    : item.path && navigate(item.path)
                }
              >
                <ListItemIcon>
                  {item.icon ? <img src={item.icon} alt="Icon" /> : <></>}
                </ListItemIcon>
                <ListItemText className="lstitm-txt" primary={item.title} />
                {item.children &&
                  (collapseState[item.collapseKey!] ? (
                    <KeyboardArrowRightIcon />
                  ) : (
                    <KeyboardArrowDownIcon />
                  ))}
              </ListItemButton>

              {item.children && (
                <Collapse
                  in={isCollapseOpen || isParentActive}
                  timeout="auto"
                  unmountOnExit
                >
                  <List component="div" disablePadding>
                    {item.children.map((child, idx) => (
                      <ListItemButton
                        key={idx}
                        selected={location.pathname === child.path}
                        onClick={() => navigate(child.path)}
                      >
                        <ListItemText primary={child.title} />
                      </ListItemButton>
                    ))}
                  </List>
                </Collapse>
              )}
            </React.Fragment>
          );
        })}
      </List>
    </>
  );

  return (
    <Box
      component="nav"
      sx={{ flexShrink: { lg: 0 } }}
      className="sidebar-main-div"
    >
      <Drawer
        className="sidebar_drawer sidebar-main-div"
        variant="temporary"
        open={mobileOpen}
        onClose={handleSidebarToggle}
        ModalProps={{ keepMounted: true }}
        sx={{
          display: { xs: "block", lg: "none" },
          "& .MuiDrawer-paper": {
            boxSizing: "border-box",
            width: SIDEBAR_WIDTH,
          },
        }}
      >
        {drawer}
      </Drawer>
      <Drawer
        variant="permanent"
        className="sidebar_drawer"
        sx={{
          display: { xs: "none", lg: "block" },
          "& .MuiDrawer-paper": {
            width: SIDEBAR_WIDTH,
            boxSizing: "border-box",
          },
        }}
        open
      >
        {drawer}
      </Drawer>
    </Box>
  );
}
